import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import {
  collectPickupOrder,
  mapTransitionError,
  useTranslation,
  type TransitionResult,
} from '@dukanti/shared';
import { toast } from 'sonner';
import { supabase } from '@/lib/supabase';

export function useCollectPickupOrder(opts: {
  readonly orderId: string;
  readonly storeId: string | null;
}): UseMutationResult<TransitionResult, unknown, void> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<TransitionResult, unknown, void>({
    retry: false,
    mutationFn: () => collectPickupOrder(supabase, opts.orderId),
    onSuccess: (result) => {
      if (!result.success) {
        toast.error(t(mapTransitionError(undefined, result, 'collect')));
        return;
      }
      void queryClient.invalidateQueries({ queryKey: ['admin-order-detail', opts.orderId] });
      if (opts.storeId)
        void queryClient.invalidateQueries({ queryKey: ['store-orders', opts.storeId] });
      void queryClient.invalidateQueries({ queryKey: ['incoming-orders-count-user'] });
      toast.success(t('admin.orders.actions.collectedSuccess'));
    },
    onError: (error) => {
      toast.error(t(mapTransitionError(error, undefined, 'collect')));
    },
  });
}
